import { motion } from "framer-motion";
import styles from "./SafeSection.module.css";
import { useTranslation } from "react-i18next";
import { container, item } from "../../../utils/animations";
import { useWindowsDimension } from "../../../../hooks/useWindowsDimension";

export const SafeSection = () => {
    const { t } = useTranslation();
    const { isMobile } = useWindowsDimension();

    return (
        <section className={styles.wrapper}>
            <motion.div
                className={styles.container}
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
            >
                <motion.div className={styles.textWrapper} variants={item}>
                    <motion.h1 className={styles.title} variants={item}>
                        {t('home.safeSection.title')}
                    </motion.h1>
                    <motion.h1 className={styles.textCoursive} variants={item}>
                        {t('home.safeSection.subtitle')}
                    </motion.h1>
                </motion.div>

                {!isMobile && (
                    <motion.img
                        src={require("../../../../assets/images/safe_people.png")}
                        alt="Safe People"
                        className={styles.peopleImage}
                        variants={item}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, amount: 0.2 }}
                    />
                )}

                <motion.img
                    src={require("../../../../assets/images/mobile_maps.png")}
                    alt="Gluten Freends App"
                    className={styles.phoneImage}
                    variants={item}
                />
            </motion.div>
        </section>
    );
};